/*!
 * cart-v2.js — v2.3 — Move to wish list ACTUALLY MOVES (Mr Porter semantics)
 *
 * v2.2 → v2.3:
 *   - Move to wish list now: (a) saves to localStorage WL, (b) removes from cart,
 *     (c) shows toast, (d) reloads cart fragment
 *   - Better error handling on cart fetch failure
 *
 * 2026-05-14 Γιάννης
 */
(function () {
  'use strict';

  /* Reuse WL global if present */
  function getWL() {
    if (typeof window.WL === 'object' && typeof window.WL.toggle === 'function') {
      return window.WL;
    }
    return {
      KEY: 'mensedit_wishlist',
      get: function () {
        try { return JSON.parse(localStorage.getItem(this.KEY) || '[]'); } catch (e) { return []; }
      },
      save: function (items) {
        try { localStorage.setItem(this.KEY, JSON.stringify(items)); } catch (e) {}
        try { window.dispatchEvent(new CustomEvent('wishlist:change')); } catch (e) {}
      },
      has: function (id) { return this.get().some(function (i) { return String(i.id) === String(id); }); },
      toggle: function (p) {
        var items = this.get();
        var idx = items.findIndex(function (i) { return String(i.id) === String(p.id); });
        if (idx > -1) { items.splice(idx, 1); this.save(items); return false; }
        items.unshift(p); this.save(items); return true;
      }
    };
  }

  /* Toast */
  var toastEl = null;
  var toastTimer = null;
  function showToast(message) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'cart-wl-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = message;
    toastEl.offsetHeight;
    toastEl.classList.add('is-visible');
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('is-visible');
    }, 2400);
  }

  /* ----------------------------------------------------------------
   * v2.3: Move to wish list — actually move (save + remove from cart)
   * ---------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wl-cart-move]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    var WL = getWL();
    var product = {
      id: btn.dataset.wlId,
      handle: btn.dataset.wlHandle,
      title: btn.dataset.wlTitle,
      image: btn.dataset.wlImage,
      url: btn.dataset.wlUrl,
      price: btn.dataset.wlPrice,
      vendor: btn.dataset.wlVendor
    };

    if (!product.id) return;

    /* 1. Add to wish list */
    var added;
    if (WL.has(product.id)) {
      added = false;
    } else {
      WL.toggle(product);
      added = true;
    }

    /* 2. Visual confirmation */
    btn.classList.add('wl-just-added');
    btn.disabled = true;
    btn.style.opacity = '0.5';

    /* 3. Toast (locale-aware) */
    var lang = (document.documentElement.lang || 'en').toLowerCase().slice(0, 2);
    var msg;
    if (lang === 'el') {
      msg = added ? 'Μεταφέρθηκε στη wish list σας' : 'Μετακινήθηκε από το καλάθι';
    } else {
      msg = added ? 'Moved to your wish list' : 'Removed from bag';
    }
    showToast(msg);

    /* 4. Remove from cart (actually move now) */
    var lineIndex = btn.dataset.wlLineIndex;
    if (lineIndex) {
      /* v2.18: wrap with MensEditButton for visible loading/success states +
         authoritative cart badge sync. */
      var labelLoading = lang === 'el' ? 'Αποθήκευση...' : 'Saving...';
      var labelSuccess = lang === 'el' ? 'Αποθηκεύτηκε' : 'Saved';

      var doRemove = function () {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: parseInt(lineIndex, 10), quantity: 0 })
        })
        .then(function (r) {
          if (!r.ok) throw new Error('cart change failed');
          return r.json();
        })
        .then(function (cart) {
          if (window.syncCartBadge) window.syncCartBadge();
          return cart;
        });
      };

      var run = window.MensEditButton
        ? window.MensEditButton.wrap(btn, {
            loadingText: labelLoading,
            successText: labelSuccess,
            successHoldMs: 800
          }, doRemove)
        : doRemove();

      run
        .then(function () {
          /* Reload to refresh UI; small delay so user sees toast + success. */
          setTimeout(function () {
            window.location.reload();
          }, 900);
        })
        .catch(function () {
          btn.disabled = false;
          btn.style.opacity = '';
          var errMsg = lang === 'el' ? 'Σφάλμα. Δοκιμάστε ξανά.' : 'Error. Please try again.';
          showToast(errMsg);
        });
    } else {
      /* No line index → can't remove from cart. Still save to wish list. */
      console.warn('Move to wish list: missing data-wl-line-index. Skipping cart removal.');
    }
  });

  /* ----------------------------------------------------------------
   * FIX 9 — Mobile sticky bar visualViewport keyboard awareness
   * ---------------------------------------------------------------- */
  function initStickyBarKeyboardAwareness() {
    var stickyBar = document.getElementById('cartStickyBar');
    if (!stickyBar) return;
    if (!('visualViewport' in window)) return;

    var rafHandle = null;
    function evaluate() {
      rafHandle = null;
      var vv = window.visualViewport;
      var ratio = vv.height / window.innerHeight;
      var isKeyboardOpen = ratio < 0.75;
      stickyBar.classList.toggle('keyboard-open', isKeyboardOpen);
    }

    function onResize() {
      if (rafHandle != null) return;
      rafHandle = window.requestAnimationFrame(evaluate);
    }

    window.visualViewport.addEventListener('resize', onResize);
    window.visualViewport.addEventListener('scroll', onResize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyBarKeyboardAwareness);
  } else {
    initStickyBarKeyboardAwareness();
  }
})();

// v2.4: Quantity controls — inline − / + buttons
document.addEventListener('click', function(e) {
  var btn = e.target.closest('.cart-qty-btn');
  if (!btn) return;
  e.preventDefault();

  var controls = btn.closest('.cart-item-qty-controls');
  if (!controls) return;
  var lineIndex = parseInt(controls.dataset.lineIndex, 10);
  if (!lineIndex) return;

  var valueEl = controls.querySelector('.cart-qty-value');
  var currentQty = parseInt(valueEl.textContent.trim(), 10) || 1;
  var action = btn.dataset.action;
  var newQty = action === 'increment' ? currentQty + 1 : Math.max(0, currentQty - 1);

  // Don't let qty go below 1 via decrement (use remove button instead)
  if (newQty < 1) return;

  // Disable both buttons during request
  controls.querySelectorAll('.cart-qty-btn').forEach(function(b) { b.disabled = true; });

  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line: lineIndex, quantity: newQty })
  })
  .then(function(r) {
    if (!r.ok) throw new Error('cart update failed');
    return r.json();
  })
  .then(function() {
    if (window.syncCartBadge) window.syncCartBadge();
    window.location.reload();
  })
  .catch(function() {
    controls.querySelectorAll('.cart-qty-btn').forEach(function(b) { b.disabled = false; });
    var lang = (document.documentElement.lang || 'en').toLowerCase().slice(0, 2);
    var errMsg = lang === 'el' ? 'Σφάλμα ενημέρωσης ποσότητας.' : 'Quantity update failed.';
    if (typeof showToast === 'function') showToast(errMsg);
    else alert(errMsg);
  });
});

/* v2.15 — Wishlist header badge count. Reads from localStorage and updates 
   on storage events + custom 'wishlist:change' event. */
(function () {
  function getWishlistCount() {
    try {
      var raw = localStorage.getItem('mensedit_wishlist');
      if (!raw) return 0;
      var items = JSON.parse(raw);
      return Array.isArray(items) ? items.length : 0;
    } catch (e) {
      return 0;
    }
  }

  function updateWishlistBadge() {
    var badge = document.getElementById('wishlist-count');
    if (!badge) return;
    var count = getWishlistCount();
    if (count > 0) {
      badge.textContent = count > 99 ? '99+' : String(count);
      badge.removeAttribute('hidden');
    } else {
      badge.textContent = '';
      badge.setAttribute('hidden', '');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateWishlistBadge);
  } else {
    updateWishlistBadge();
  }

  /* React to wish list changes from this tab */
  window.addEventListener('wishlist:change', updateWishlistBadge);

  /* React to wish list changes from other tabs */
  window.addEventListener('storage', function (e) {
    if (e.key === 'mensedit_wishlist') updateWishlistBadge();
  });

  /* Expose for manual triggering */
  window.updateWishlistBadge = updateWishlistBadge;
})();

/* ============================================================
 * v2.18 — Authoritative cart badge sync + button interaction states
 * ============================================================
 *
 * Bug 1: cart-icon.js:78 uses `current + new` increment for PDP adds, plus
 * sessionStorage cache fights truth. Fix: after every `cart:update` event
 * (Horizon's literal event name; see assets/events.js:14), refetch /cart.js
 * and authoritative-set the badge.
 *
 * Bug 2: silent button presses. MensEditButton.wrap puts buttons through
 * pressed → loading → success states via data-state attribute.
 */

(function () {
  /* ---------- Cart badge sync ---------- */
  var CART_BADGE_SELECTORS = [
    '.cart-bubble__text-count',
    '[data-testid="cart-bubble"]',
    '[ref="cartBubbleCount"]'
  ];
  var CART_WRAPPER_SELECTORS = ['.cart-bubble'];

  function setCartBadge(count) {
    var displayCount = count > 99 ? '99+' : String(count);

    /* Update count text */
    var seen = new Set();
    CART_BADGE_SELECTORS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (n) {
        if (seen.has(n)) return;
        seen.add(n);
        if (count > 0) {
          n.textContent = displayCount;
          n.classList.remove('hidden');
          n.removeAttribute('hidden');
          /* Pulse animation — reflow trick to restart */
          n.classList.remove('cart-badge-pulse');
          void n.offsetWidth;
          n.classList.add('cart-badge-pulse');
        } else {
          n.textContent = '';
          n.classList.add('hidden');
        }
      });
    });

    /* Toggle wrapper visibility */
    CART_WRAPPER_SELECTORS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (w) {
        w.classList.toggle('visually-hidden', count === 0);
      });
    });

    /* Keep sessionStorage in sync so cart-icon.js's ensureCartBubbleIsCorrect
       on next pageshow doesn't restore a stale count. */
    try {
      sessionStorage.setItem('cart-count', JSON.stringify({
        value: String(count),
        timestamp: Date.now()
      }));
    } catch (e) { /* ignore quota / private mode errors */ }
  }

  function syncCartBadge() {
    return fetch('/cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        setCartBadge(cart.item_count || 0);
        return cart;
      })
      .catch(function (e) {
        console.warn('[v2.18] cart sync failed', e);
      });
  }

  /* Sync on load to correct any stale badge from prior session */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncCartBadge);
  } else {
    syncCartBadge();
  }

  /* Listen for theme + our custom events. 'cart:update' is Horizon's literal
     (assets/events.js:14). Others are defensive aliases. */
  ['cart:update', 'cart:change', 'cart:updated', 'cart:added', 'cart:removed',
   'mensedit:cart-changed'].forEach(function (evt) {
    /* Schedule on next tick so we run AFTER cart-icon.js's increment-handler,
       letting our server-truth value win the final paint. */
    document.addEventListener(evt, function () {
      setTimeout(syncCartBadge, 0);
    });
    window.addEventListener(evt, function () {
      setTimeout(syncCartBadge, 0);
    });
  });

  window.syncCartBadge = syncCartBadge;

  /* ---------- MensEditButton.wrap helper ---------- */
  function setState(btn, state, label) {
    if (!btn) return;
    if (state) {
      btn.setAttribute('data-state', state);
      if (label !== undefined && label !== null && label !== '') {
        if (!btn.dataset.originalLabel) {
          btn.dataset.originalLabel = btn.textContent;
        }
        btn.textContent = label;
      }
    } else {
      btn.removeAttribute('data-state');
      if (btn.dataset.originalLabel) {
        btn.textContent = btn.dataset.originalLabel;
        delete btn.dataset.originalLabel;
      }
    }
  }

  window.MensEditButton = {
    wrap: function (btn, opts, asyncFn) {
      opts = opts || {};
      var loadingText = opts.loadingText || '';
      var successText = opts.successText || '';
      var successHoldMs = opts.successHoldMs || 800;

      setState(btn, 'loading', loadingText);

      return Promise.resolve()
        .then(function () { return asyncFn(); })
        .then(function (result) {
          setState(btn, 'success', successText);
          setTimeout(function () { setState(btn, null); }, successHoldMs);
          return result;
        })
        .catch(function (err) {
          setState(btn, null);
          throw err;
        });
    }
  };
})();

/* v2.19 — PDP add-to-cart visual feedback overlay.
   Non-invasive: doesn't replace Horizon's <add-to-cart-component> handler.
   Just listens for clicks (capture phase) + cart:update event to manage
   data-mensedit-state attribute, which CSS uses to render spinner/check. */
(function () {
  function isPDPAddToCart(btn) {
    if (!btn) return false;
    // v2.20: hard exclusion — checkout button must never be captured by PDP overlay
    if (btn.matches('[name="checkout"], [data-mensedit-no-overlay], .cart__checkout-button, .cart__checkout-button--luxury')) return false;
    // Horizon custom element
    if (btn.closest('add-to-cart-component')) return true;
    // Standard product form
    if (btn.matches('button[name="add"], [type="submit"][name="add"]')) return true;
    // Inside a product form pointing to /cart/add
    var form = btn.closest('form');
    if (form && form.getAttribute('action') && form.getAttribute('action').indexOf('/cart/add') !== -1) {
      return true;
    }
    return false;
  }

  function applyState(btn, state) {
    if (!btn) return;
    if (state) {
      btn.setAttribute('data-mensedit-state', state);
    } else {
      btn.removeAttribute('data-mensedit-state');
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('button, a, [role="button"]');
    if (!btn) return;
    if (!isPDPAddToCart(btn)) return;
    if (btn.disabled) return;
    if (btn.getAttribute('data-mensedit-state')) return;

    // Set loading state immediately (do not preventDefault — let Horizon run)
    applyState(btn, 'loading');

    var settled = false;
    var onCartUpdate = function () {
      if (settled) return;
      settled = true;

      // Brief minimum loading visibility (300ms) so flash is perceivable
      // even on lightning-fast AJAX. Then show success for 1000ms.
      setTimeout(function () {
        applyState(btn, 'success');
        setTimeout(function () { applyState(btn, null); }, 1100);
      }, 200);

      cleanup();
    };
    var cleanup = function () {
      window.removeEventListener('cart:update', onCartUpdate);
      document.removeEventListener('cart:update', onCartUpdate);
      window.removeEventListener('cart:added', onCartUpdate);
      document.removeEventListener('cart:added', onCartUpdate);
      window.removeEventListener('cart:change', onCartUpdate);
      document.removeEventListener('cart:change', onCartUpdate);
    };

    window.addEventListener('cart:update', onCartUpdate);
    document.addEventListener('cart:update', onCartUpdate);
    window.addEventListener('cart:added', onCartUpdate);
    document.addEventListener('cart:added', onCartUpdate);
    window.addEventListener('cart:change', onCartUpdate);
    document.addEventListener('cart:change', onCartUpdate);

    // Safety timeout: if no event fires within 6s (e.g., network failure),
    // clear loading state so user can retry.
    setTimeout(function () {
      if (!settled) {
        settled = true;
        applyState(btn, null);
        cleanup();
      }
    }, 6000);
  }, true /* capture */);
})();

/* ============================================================
 * v2.20 — Checkout-click defense in depth (post-publish hotfix)
 * ============================================================ */

/* Clear stuck data-state attributes on pageshow (handles bfcache scenarios
   where loading/success state may persist from a prior navigation). */
window.addEventListener('pageshow', function () {
  document.querySelectorAll('[data-state="loading"], [data-state="success"], [data-mensedit-state]')
    .forEach(function (el) {
      el.removeAttribute('data-state');
      el.removeAttribute('data-mensedit-state');
    });
});

/* Belt: mark checkout buttons with a sentinel so the v2.19 overlay logic
   plus the CSS exemption below treat them as never-overlayable. */
(function () {
  function markCheckoutButtons() {
    document.querySelectorAll(
      'button[name="checkout"], .cart__checkout-button, .cart__checkout-button--luxury'
    ).forEach(function (btn) {
      btn.setAttribute('data-mensedit-no-overlay', 'true');
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', markCheckoutButtons);
  } else {
    markCheckoutButtons();
  }
  /* Re-run on cart updates in case Shopify section-rendering swaps the
     checkout button DOM node. */
  ['cart:update', 'cart:change'].forEach(function (evt) {
    window.addEventListener(evt, function () { setTimeout(markCheckoutButtons, 0); });
    document.addEventListener(evt, function () { setTimeout(markCheckoutButtons, 0); });
  });
})();
